export default __webpack_public_path__ + "static/Alexandra-b73a0e9636d0e6677d7c7538915b795d.jpg";